import { useMemo, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { apiPost } from '../../services/api';

export default function AcceptInvitePage() {
  const [searchParams] = useSearchParams();
  const token = useMemo(() => searchParams.get('token') || '', [searchParams]);

  const [form, setForm] = useState({
    firstName: '',
    lastName: '',
    password: '',
    confirmPassword: '',
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    if (!token) {
      setError('Invitation token is missing.');
      return;
    }
    if (form.password.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }
    if (form.password !== form.confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    setLoading(true);
    try {
      await apiPost('/invitations/accept', {
        token,
        firstName: form.firstName,
        lastName: form.lastName,
        password: form.password,
      });
      setMessage('Invitation accepted. Your account is ready. You can sign in now.');
      setForm({ firstName: '', lastName: '', password: '', confirmPassword: '' });
    } catch (err) {
      setError(err.message || 'Failed to accept invitation.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-secondary-50 p-8 flex items-center justify-center">
      <div className="w-full max-w-md bg-white border border-secondary-200 rounded-xl p-6">
        <h1 className="text-2xl font-display font-bold text-secondary-900">Accept Invitation</h1>
        <p className="text-sm text-secondary-600 mt-1">Create your account to join your organization.</p>

        {error ? (
          <div className="mt-4 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">{error}</div>
        ) : null}
        {message ? (
          <div className="mt-4 rounded-lg border border-green-200 bg-green-50 px-3 py-2 text-sm text-green-700">{message}</div>
        ) : null}

        <form onSubmit={submit} className="mt-5 space-y-3">
          <div className="grid grid-cols-2 gap-3">
            <input
              className="input"
              placeholder="First name"
              value={form.firstName}
              onChange={(e) => setForm((p) => ({ ...p, firstName: e.target.value }))}
              required
            />
            <input
              className="input"
              placeholder="Last name"
              value={form.lastName}
              onChange={(e) => setForm((p) => ({ ...p, lastName: e.target.value }))}
              required
            />
          </div>
          <input
            type="password"
            className="input"
            placeholder="Password"
            value={form.password}
            onChange={(e) => setForm((p) => ({ ...p, password: e.target.value }))}
            required
            minLength={8}
          />
          <input
            type="password"
            className="input"
            placeholder="Confirm password"
            value={form.confirmPassword}
            onChange={(e) => setForm((p) => ({ ...p, confirmPassword: e.target.value }))}
            required
            minLength={8}
          />
          <button type="submit" className="btn-primary w-full" disabled={loading}>
            {loading ? 'Accepting...' : 'Accept Invitation'}
          </button>
        </form>

        <div className="mt-4 text-center">
          <Link to="/login" className="text-sm text-primary-600 hover:underline">Go to Login</Link>
        </div>
      </div>
    </div>
  );
}
